import { parseCaptionWhenAltTextEmpty } from 'utils/parsingUtils/clientSideParsing';
import { type SocialItem, SocialList, SocialListStyle } from 'components/SocialList';
import type { AuthorBioConfig } from 'interfaces/content/Authors';
import rawHtml from 'utils/miscUtils/rawHtml';
import Link from 'components/Globals/Base/Link';
import { COMMON_TEST_IDS } from 'constants/testsIds/common';
import { withErrorBoundary } from 'components/ErrorBoundary';
import { UIFragments } from 'utils/log/constants/uiFragments';
import * as S from './AuthorBioStyles';
import { InfoContainer } from './AuthorBioStyles';

const AuthorBio = (props: AuthorBioConfig) => {
  const { author, className, toggleTooltip } = props;

  const socials = [] as SocialItem[];

  if (author.social?.instaUrl) {
    socials.push({
      type: 'instagram',
      url: author.social.instaUrl,
    } as SocialItem);
  }

  if (author.social?.linkedinUrl) {
    socials.push({
      type: 'linkedin',
      url: author.social.linkedinUrl,
    } as SocialItem);
  }

  if (author.social?.twitterUrl) {
    socials.push({
      type: 'twitter',
      url: author.social.twitterUrl,
    } as SocialItem);
  }

  return (
    <S.Wrapper
      className={className}
      id='author-bio'
      data-cy={COMMON_TEST_IDS.AUTHOR_BIO}
    >
      <S.Header>
        {author.image && (
          <Link
            href={author.uri}
            data-cy={COMMON_TEST_IDS.AUTHOR_LINK}
            ariaLabel={`Go to ${author.name} author's page`}
          >
            <S.Image
              src={author.image}
              alt={parseCaptionWhenAltTextEmpty(author.image)}
              width={0}
              height={0}
              sizes='5vw'
              data-cy={COMMON_TEST_IDS.AUTHOR_IMAGE}
            />
          </Link>
        )}
        <InfoContainer>
          <Link
            href={author.uri}
            data-cy={COMMON_TEST_IDS.AUTHOR_LINK}
          >
            <S.Name data-cy={COMMON_TEST_IDS.AUTHOR_NAME}>{author.name}</S.Name>
          </Link>
          <S.Role data-cy={COMMON_TEST_IDS.AUTHOR_ROLE}>{author.role}</S.Role>
        </InfoContainer>
        {toggleTooltip && (
          <S.CloseButton
            onClick={() => toggleTooltip(false)}
            data-cy={COMMON_TEST_IDS.AUTHOR_CLOSE_BUTTON}
          />
        )}
      </S.Header>
      <SocialList
        items={socials}
        style={SocialListStyle.Square}
      />
      {author.funFactHeader && author.funFactHeader && (
        <S.FactContainer data-cy={COMMON_TEST_IDS.AUTHOR_FUN_FACT}>
          <span>{author.funFactHeader}:</span>
          <S.FactValue>{author.funFactValue}</S.FactValue>
        </S.FactContainer>
      )}
      {author.shortIntro && (
        <S.Bio data-cy={COMMON_TEST_IDS.AUTHOR_SHORT_INTRO}>{rawHtml({ html: author.shortIntro || '' })}</S.Bio>
      )}
      <S.Footer>
        <S.BioLink
          type='tertiaryBlackButton'
          href={author.uri}
          data-cy={COMMON_TEST_IDS.AUTHOR_SEE_FULL_BIO}
          className='bio-link'
        >
          SEE FULL BIO
        </S.BioLink>
      </S.Footer>
    </S.Wrapper>
  );
};

export default withErrorBoundary(AuthorBio, { fragment: UIFragments.AUTHOR_BIO });
